class GoogleAuthenticationService {

	public static fetchUserInfo = (accessToken: string) => {
		return new Promise((resolve, reject) => {
			fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
				headers: {
					Authorization: `Bearer ${accessToken}`
				},
			}).then(response => {
				if (response.ok) {
					resolve(response.json());
				} else {
					reject('Failed to fetch user info from Google');
				}
			});
		});
	};
}

export default GoogleAuthenticationService;